export function setFormIncorporationConsumption(state, data) {
    state.formIncorporationConsumption = {
        ...state.formIncorporationConsumption,
        ...data
    };
}

export function setFormIncorporationUsersConsumption(state, data) {
    state.formIncorporationConsumption = {
        ...state.formIncorporationConsumption,
        ...data
    };
}

export function setFormBankConciliation(state, data) {
    state.formBankConciliation = {
        ...state.formBankConciliation,
        ...data
    };
}

export function setDataBankConciliation(state, data) {
    state.dataBankConciliation = data;
}

export function setFormIncorporationConsumptionLoading(state, value) {
    state.formIncorporationConsumptionLoading = value;
}

export function setDocuments(state, data) {
    state.documents = data.map(item => {
        const sumTotalValue = item.documents_products.reduce(
            (acc, product) => {
                return (
                    acc + (parseFloat(product.total_value) || 0)
                );
            },
            0
        );

        return {
            ...item,
            total_value: sumTotalValue
        }
    });
}

export function setDocumentsByUserIdLoading(state, value) {
    state.documentsByUserIdLoading = value;
}

export function setSubscriber(state, value) {
    state.subscriber = value;
}

export function setContacts(state, value) {
    state.contacts = value;
}

export function setContact(state, value) {
    state.selectedContact = value;
}




// WEBPACK FOOTER //
// ./src/modules/incorporation-consumption/mutations.js